let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("hWm6t")).then(() => parcelRequire('6B1xj'));